<p-toast position="top-right" key="tc"></p-toast>
<p-confirmPopup></p-confirmPopup>

<div>

    <div class="mt-3">
        <h3>Übersicht Benutzer</h3>
        <p-divider></p-divider>
        @if(loading) {
        <p><i class="pi pi-spin pi-spinner mr-1" style="font-size: 2rem"></i><span>Bitte warten - Benutzer werden
                geladen....</span></p>
        } @else {

        <div class="content">
            <p-button label="Neuen Benutzer anlegen" (click)="newUser()" styleClass="p-button-raised"
                icon="pi pi-user-plus"></p-button>
            <p-divider></p-divider>
            <p-table #dt [value]="users" [autoLayout]="true"
                styleClass="p-datatable-striped p-datatable-sm p-datatable-gridlines"
                [globalFilterFields]="['firstname','lastname','email']" [paginator]="usersCount > 10" [rows]="10"
                [showCurrentPageReport]="true"
                currentPageReportTemplate="Zeige {first} bis {last} von {totalRecords} Einträgen"
                [rowsPerPageOptions]="[10,25,50,100]" styleClass="shadow-2 p-datatable-striped">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Vorname</th>
                        <th>Nachname</th>
                        <th>Email-Adresse</th>
                        <th>Administrator</th>
                        <th style="min-width: 90px;"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-user let-index="index">
                    <tr>
                        <td>{{user.firstname}}</td>
                        <td>{{user.lastname}}</td>
                        <td>{{user.email}}</td>
                        <td>{{ getAdminState(user.is_administrator) }}</td>
                        <td class="p-text-nowrap">
                            <p-button pRipple label="Bearbeiten" (click)="editUser(user)" icon="pi pi-user-edit"
                                styleClass="p-button-raised"></p-button>
                            <p-button pRipple label="Löschen" (click)="deleteUser($event, user.usersid, index)"
                                [disabled]="user.deletable == 0" icon="pi pi-trash"
                                styleClass="ml-2 p-button-raised p-button-danger"></p-button>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="11"><b>Es wurden keine Daten gefunden!</b></td>
                    </tr>
                </ng-template>
            </p-table>
            <p-divider></p-divider>
        </div>
        }
    </div>
</div>